import { useState } from 'react';
import { t } from '../Table.styles';
import styled from 'styled-components';
import MoreButton from '../../../components/moreButton/MoreButton';

const BiddingInfo = ({ bidHistory }: any) => {
  const [showAll, setShowAll] = useState(false);
  const bidHistoryArray = JSON.parse(bidHistory);

  return (
    <Container id="입찰정보">
      <Block>
        <Title>입찰정보</Title>
        <t.Table>
          <thead>
            <t.Row>
              <t.TableHeadTh width="20%">
                입찰번호 <br />
                (회차/차수)
              </t.TableHeadTh>
              <t.TableHeadTh width="30%">
                입찰기간/ <br />
                개찰일시
              </t.TableHeadTh>
              <t.TableHeadTh width="30%">
                대금납부/기한/매각결정일
              </t.TableHeadTh>
              <t.TableHeadTh width="20%">
                최저 <br />
                입찰가
              </t.TableHeadTh>
            </t.Row>
          </thead>
          <tbody>
            {bidHistoryArray
              .slice(1, showAll ? bidHistoryArray.length : 3)
              .map((item: any, index: number) => (
                <t.Row key={index}>
                  <t.ContentCell width="20%" border={true} textAlign="center">
                    {item[0]} <br />
                    {item[1]}
                  </t.ContentCell>
                  <t.ContentCell width="30%" border={true} textAlign="center">
                    {item[4]} <br />
                    개찰: {item[5]}
                  </t.ContentCell>
                  <t.ContentCell width="30%" border={true} textAlign="center">
                    {item[3]} <br />
                    {item.length < 10
                      ? ''
                      : `${item[7].split('||')?.[0] || item[7]}`}
                  </t.ContentCell>
                  <t.ContentCell width="20%" border={true} textAlign="center">
                    {item.length < 10
                      ? `${item[7]}원`
                      : item[9]
                        ? `${item[9]} 원`
                        : ''}
                  </t.ContentCell>
                </t.Row>
              ))}
          </tbody>
        </t.Table>
        {bidHistoryArray.length > 3 && (
          <MoreButton
            name="입찰정보"
            showAll={showAll}
            setShowAll={setShowAll}
            sectionId="입찰정보"
          />
        )}
      </Block>
    </Container>
  );
};

export default BiddingInfo;

const Container = styled.div`
  width: 100%;
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  font-family: Spoqa Han Sans Neo;
  background-color: #fff;
`;

const Block = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const Title = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: #222;
`;
